import type { LocationQueryValue, NavigationGuard } from 'vue-router';
import type { RouteNameFromPath, TypedLocalePathParameter } from '@typed-router';

/** Guard routes by requiring specific query params, optionally showing a translated warning. */
export default function requiredQueryParams(requiredParams: string[], redirectTo: TypedLocalePathParameter<RouteNameFromPath<string>>, notificationKey?: string): NavigationGuard {
  return (to) => {
    function isQueryParamMissing(param: LocationQueryValue | undefined): boolean {
      return param == null || param === '';
    }

    const hasMissingParams = requiredParams.some((param) => {
      const value = to.query[param as keyof typeof to.query];

      if (Array.isArray(value)) {
        return value.length === 0 || value.every(isQueryParamMissing);
      }

      return isQueryParamMissing(value);
    });

    if (!hasMissingParams) return;

    if (notificationKey) {
      const { t } = useI18n();
      const notificationStore = useNotificationsStore();

      notificationStore.add({
        status: 'warning',
        message: t(notificationKey),
        timeout: 5000,
      });
    }

    const localePath = useLocalePath();
    return navigateTo(localePath(redirectTo));
  };
}
